export default __webpack_public_path__ + "static/media/H521119_tn.956a7996.jpg";